/* noted. — Skipstone allocation table: member pricing.

   Awtomic's allocation table prints retail on every line and subtracts the
   club discount once at the bottom, so a member never sees what they actually
   pay per bottle. This renders retail struck through beside the member price
   on each line, from the table in assets/skipstone-tiers.js.

   THE SUBTOTAL STILL READS RETAIL, ON PURPOSE. Awtomic computes it and bills
   from it, and the discount row beneath reconciles the two. Rewriting it would
   mean recomputing a figure money depends on, and if the two ever disagreed
   the member would trust the one on screen. Display is ours. Arithmetic is
   not.

   WHY THE FIRST TWO ATTEMPTS FOUND NOTHING. Both looked the cells up by name:
   data-testid="price-line", then data-label="Price", then .body_row__price.
   The wine rows carry NONE of those. Read from the live DOM:

     <tr class="bundle-table__body-row bundle-table__body-row--bab-child">
       <td>...<h3 class="awt-bab-product-name">2024 Malbec - 750ml</h3></td>
       <td><div class="awt-bab-product-line-qty">3</div></td>
       <td>$150.00</td>
       <td><p>$450.00</p></td>
     </tr>

   Bare <td>s. No class, no attribute, nothing to select by. Only the
   membership row carries named cells, and even there the class is
   body-row__product-detail with a HYPHEN, not the underscore this build had
   been writing.

   So the cells are found by SHAPE instead: within a row, the money cells are
   the ones whose whole text is a currency figure. The first is the unit price,
   the last is the line total, and quantity is the cell before the first money
   cell. That holds for both row shapes and does not care what Awtomic calls
   anything.

   The lesson, for the fifth time in this build: Awtomic's class names are not
   a contract. Select on structure you can see, never on a name you hope is
   there. */
(function () {
  "use strict";
  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  var MONEY = /^\s*\$\s*[\d,]+(\.\d{2})?\s*$/;

  function fmt(n) {
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function num(text) {
    return parseFloat(String(text).replace(/[^0-9.]/g, ""));
  }

  function priceFor(text) {
    var list = window.SKIPSTONE_PRICES || [];
    var t = (text || "").toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (t.indexOf(String(list[i].match).toLowerCase()) !== -1) return list[i];
    }
    return null;
  }

  function render(el, retail, member) {
    var s = document.createElement("s");
    s.textContent = fmt(retail);
    s.style.opacity = ".5";
    s.style.marginRight = ".55em";
    s.style.fontWeight = "400";

    var b = document.createElement("span");
    b.textContent = fmt(member);
    b.style.fontWeight = "600";

    el.textContent = "";
    el.appendChild(s);
    el.appendChild(b);
  }

  function run() {
    var list = window.SKIPSTONE_PRICES || [];
    if (!list.length) return;

    var tables = document.querySelectorAll("table");
    Array.prototype.forEach.call(tables, function (t) {
      var body = t.tBodies && t.tBodies[0];
      if (!body) return;

      Array.prototype.forEach.call(body.rows, function (row) {
        if (row.getAttribute("data-skipstone-priced") === "yes") return;

        var p = priceFor(row.textContent);
        if (!p) return;

        /* money cells by shape, not by name */
        var cells = Array.prototype.slice.call(row.cells);
        var moneyIdx = [];
        cells.forEach(function (c, i) {
          if (MONEY.test(c.textContent || "")) moneyIdx.push(i);
        });
        if (moneyIdx.length < 1) return;

        var priceCell = cells[moneyIdx[0]];
        var totalCell = moneyIdx.length > 1 ? cells[moneyIdx[moneyIdx.length - 1]] : null;

        /* Only rewrite a cell still showing retail. If Awtomic ever prints the
           member price itself, leave it rather than striking a correct one. */
        if (num(priceCell.textContent) !== p.retail) {
          row.setAttribute("data-skipstone-priced", "yes");
          return;
        }

        var qty = NaN;
        if (moneyIdx[0] > 0) qty = parseInt(cells[moneyIdx[0] - 1].textContent, 10);

        render(priceCell, p.retail, p.member);
        if (totalCell && !isNaN(qty) && qty > 0) {
          render(totalCell, p.retail * qty, p.member * qty);
        }

        row.setAttribute("data-skipstone-priced", "yes");
      });
    });
  }

  function safeRun() {
    try { run(); } catch (e) { console.warn("[skipstone-portal-pricing]", e); }
  }

  /* NEVER requestAnimationFrame HERE. rAF does not fire in a hidden or
     backgrounded tab, so `queued` latches true and the observer goes deaf for
     the rest of the page's life. That is exactly how this file shipped on
     2026-08-21 and rendered nothing: the allocation table painted after the
     last timeout, the observer fired once, and the frame it was waiting on
     never came. Same bug, same fix, as skipstone-bundle-order.js.
     setTimeout always fires. Verified on the live portal 2026-08-24: the
     matcher and cell-detection were already correct and priced all 7 eligible
     rows the moment run() was called by hand. Only the scheduler was broken. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; safeRun(); }, 50);
  }

  function start() {
    try {
      safeRun();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      /* Awtomic paints the table after our first pass, and again once its own
         data settles. The ladder runs long enough to outlast a slow phone. */
      [200, 600, 1200, 1800, 3000, 4500, 6000, 9000].forEach(function (ms) {
        setTimeout(safeRun, ms);
      });
    } catch (e) {
      console.warn("[skipstone-portal-pricing] disabled", e);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
